<div id="openExtendsProductPriceUnit" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mt-0 ng-binding">Lista precios por unidad de medida</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <div class="modal-body" *ngIf="item != null">
        <div class="form-group">
          <span class="bold">PRODUCTO : </span>
          <span>{{item.description}}</span>
        </div>
        <div class="form-group">
          <div class="table-responsive">
            <table class="table mb-0 table-sm">
              <thead class="thead-default">
                <tr>
                  <th class="text-center">Unidad Medida</th>
                  <th class="text-center">Equivalencia</th>
                  <th class="text-center">Precio venta</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="item.unitsmeasure.length == 0">
                  <tr>
                    <td colspan="2"><span>No se encontraron registros</span></td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="item.unitsmeasure.length > 0">
                  <tr *ngFor="let unit of item.unitsmeasure">
                    <td class="text-center">{{unit.description}}</td>
                    <td class="text-center">{{unit.equivalence}}</td>
                    <td class="text-center">{{unit.price_sale}}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal">Cerrar ventana</button>
      </div>
    </div>
  </div>
</div>
